import Common from "./Common";

const CommonAPI = {

    expireCache: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Brand/ExpireCache", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },

    sendMessage: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Brand/contactUs", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },

    getTestimonials : async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Testimonial/getAll", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },

    getActiveTestimonials : async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Testimonial/getActive", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },

    getActiveTestimonialsTransformed : async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Testimonial/getActiveTransformedFromCache", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },

    getJobs : async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Jobs/GetActiveFromCache", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },

    getDivers: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Divers/GetAll", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },

    searchDiver: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Divers/Search", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },

    getBakeryCateringItemsOnlyActive: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/CateringItems/GetActiveFromCache", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },

    getBakeryCakesOnlyActive: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Cakes/GetActiveFromCache", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },

    getBakeryCanapesOnlyActive: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Canapes/GetActiveFromCache", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },

    getBakeryPiesOnlyActive: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/Pies/GetActiveFromCache", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    },

    getBakeryAddOnsOnlyActive: async function (inputParmaeter, callbackMethod, callbackData, callbackErrorMethod) {
        Common.call("api/AddOns/GetActiveFromCache", inputParmaeter, callbackMethod, callbackData, callbackErrorMethod);
    }
};

export default CommonAPI;
